/* KPI tile (E1 "Your awards · since 2025"). */
.stat {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 22px;
  background: var(--surface-card);
  border: 1px solid var(--border-card);
  border-radius: var(--radius-md);
}

.labelRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.label {
  margin: 0;
  color: var(--text-muted);
}

.value {
  margin: 0;
  color: var(--text-heading);
  font-size: 32px;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.gold .value {
  color: var(--text-gold);
}

.muted .value {
  color: var(--text-muted);
}

.note {
  margin: 0;
  color: var(--text-muted);
  font-size: 12px;
  line-height: 1.45;
}

.notSet {
  border-style: dashed;
  border-color: var(--border-dashed);
  background: var(--surface-ground);
}

.notSet .note,
.notSet .label {
  color: var(--text-secondary);
}

.notSet .value {
  color: var(--text-muted);
  font-size: 26px;
}

.notSetLink {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  min-height: var(--control-height);
  font-size: 13px;
  font-weight: var(--fw-semibold);
}
